import {
    getOrderDetailsComments,
    getQuotationDetailsComments,
    setOrderDetailsError,
    insertOrderCircuitComments,
    resetOrderCircuitComments,
    insertQuotationCircuitComments,
    resetQuotationCircuitComments
} from "../../../constants/model-reducers/external/order/order-details-comments.settings";
import { httpGet, httpPost, httpPostFile } from "../../../utils/api.utils";

const defaultState = () => ({
    OrderDetailsComments: [],
    hasMoreComments: false,
    commentsPage: 1,
});

const initialState = defaultState();

export const orderDetailsCommentsActions = {
    postOrderDetailsComments: (orderID, filename, fileData, comment) => async (dispatch, state) => {

        var formData = new FormData();
        var user = JSON.parse(sessionStorage.getItem('User'));

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("OrderId", orderID);
        formData.append("CreatedBy", user.Employee.Email);
        formData.append("CreatedById", parseInt(sessionStorage.getItem('UserID')),);

        var res = await httpPostFile('external/order/setOrderDetailsComments', formData);

        if (res != null) {
            dispatch({
                type: insertOrderCircuitComments,
                OrderDetailsComments: [res?.orderDetailsComments[0]],
                isOrderDetailsLoaded: true,
                isOrderDetailsError: false
            });
        } else {
            dispatch({
                type: setOrderDetailsError,
                isOrderDetailsError: true,
                isOrderDetailsLoaded: false
            });
        }
    },

    postQuotationDetailsComments: (quotedRequestID, filename, fileData, comment) => async (dispatch, state) => {

        var formData = new FormData();
        var user = JSON.parse(sessionStorage.getItem('User'));

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("QuotedRequestId", quotedRequestID);
        formData.append("CreatedBy", user.Employee.Email);
        formData.append("CreatedById", parseInt(sessionStorage.getItem('UserID')),);

        var res = await httpPostFile('external/order/setQuotationDetailsComments', formData);

        if (res != null) {
            dispatch({
                type: insertQuotationCircuitComments,
                OrderDetailsComments: [res?.quotationDetailsComments[0]],
                isOrderDetailsLoaded: true,
                isOrderDetailsError: false
            });
        } else {
            dispatch({
                type: setOrderDetailsError,
                isOrderDetailsError: true,
                isOrderDetailsLoaded: false
            });
        }
    },

    getOrderDetailsComments: (orderID, pageIndex = 1, pageSize = 5) => async (dispatch, state) => {
        const existingComments = state().orderDetailsComments?.OrderDetailsComments || [];
        const lastCommentId = existingComments.length > 0
            ? existingComments[existingComments.length - 1].CommentID
            : null;

        const url = `external/order/getOrderDetailsComments/${pageIndex}/${pageSize}?orderID=${orderID}`
            + (lastCommentId ? `&lastCommentId=${lastCommentId}` : "");

        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getOrderDetailsComments,
                OrderDetailsComments: res?.orderDetailsComments,
                isOrderDetailsLoaded: true,
                isOrderDetailsError: false,
                commentsPage: pageIndex,
                hasMoreData: res.hasMoreData
            });
        } else {
            dispatch({
                type: setOrderDetailsError,
                isOrderDetailsError: true,
                isOrderDetailsLoaded: false
            });
        }
    },

    getQuotationDetailsComments: (quotedRequestID, pageIndex = 1, pageSize = 5) => async (dispatch, state) => {
        const existingComments = state().orderDetailsComments?.OrderDetailsComments || [];
        const lastCommentId = existingComments.length > 0
            ? existingComments[existingComments.length - 1].CommentID
            : null;
           
        const url = `external/order/getQuotationDetailsComments/${pageIndex}/${pageSize}?quotedRequestID=${quotedRequestID}`
            + (lastCommentId ? `&lastCommentId=${lastCommentId}` : "");

        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getQuotationDetailsComments,
                OrderDetailsComments: res.quotationDetailsComments,
                isOrderDetailsLoaded: true,
                isOrderDetailsError: false,
                commentsPage: pageIndex,
                hasMoreData: res.hasMoreData
            });
        } else {
            dispatch({
                type: setOrderDetailsError,
                isOrderDetailsError: true,
                isOrderDetailsLoaded: false
            });
        }
    },

    deleteOrderDetailsComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost(`external/order/orderDetailsDeleteComment/${commentId}/${userId}`);

        if (res == null) {
            dispatch({
                type: setOrderDetailsError,
                isOrderDetailsError: true,
                isOrderDetailsLoaded: false
            });

        }
    },

    deleteQuotationDetailsComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost(`external/order/quotationDetailsDeleteComment/${commentId}/${userId}`);

        if (res == null) {
            dispatch({
                type: setOrderDetailsError,
                isOrderDetailsError: true,
                isOrderDetailsLoaded: false
            });

        }
    },

    resetOrderCircuitComments: () => (dispatch) => {
        dispatch({
            type: resetOrderCircuitComments,
        })
    },

    resetQuotationCircuitComments: () => (dispatch) => {
        dispatch({
            type: resetQuotationCircuitComments,
        })
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getOrderDetailsComments: {
            return {
                ...state,
                OrderDetailsComments: [
                    ...(state.OrderDetailsComments || []),
                    ...(action.OrderDetailsComments || [])
                ],
                hasMoreComments: action.hasMoreData,
                commentsPage: action.commentsPage
            };
        }
        case getQuotationDetailsComments: {
            return {
                ...state,
                OrderDetailsComments: [
                    ...(state.OrderDetailsComments || []),
                    ...(action.OrderDetailsComments || [])
                ],
                hasMoreComments: action.hasMoreData,
                commentsPage: action.commentsPage
            };
        }
        case insertOrderCircuitComments: {
            const combinedComments = [
                ...action.OrderDetailsComments,
                ...state.OrderDetailsComments
            ];
            const currentVisibleCount = state.OrderDetailsComments.length;
            const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
            const hasMore = combinedComments.length > currentDisplayLimit && combinedComments.length !== 1;
            let updatedComments;
            if (hasMore) {
                updatedComments = combinedComments.slice(0, -1);
            } else {
                updatedComments = combinedComments;
            }
            return {
                ...state,
                OrderDetailsComments: combinedComments.length === 1 ? action.OrderDetailsComments : updatedComments,
                hasMoreComments: hasMore,

            };
        }
        case resetOrderCircuitComments: {
            return {
                ...state,
                OrderDetailsComments: [],
                hasMoreComments: false,
                commentsPage: 1
            };
        }
        case insertQuotationCircuitComments: {
            const combinedComments = [
                ...action.OrderDetailsComments,
                ...state.OrderDetailsComments
            ];
            const currentVisibleCount = state.OrderDetailsComments.length;
            const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
            const hasMore = combinedComments.length > currentDisplayLimit && combinedComments.length !== 1;
            let updatedComments;
            if (hasMore) {
                updatedComments = combinedComments.slice(0, -1);
            } else {
                updatedComments = combinedComments;
            }
            return {
                ...state,
                OrderDetailsComments: combinedComments.length === 1 ? action.OrderDetailsComments : updatedComments,
                hasMoreComments: hasMore,

            };
        }

        case resetQuotationCircuitComments: {
            return {
                ...state,
                OrderDetailsComments: [],
                hasMoreComments: false,
                commentsPage: 1
            };
        }
        case setOrderDetailsError: {
            return {
                ...state,
                isOrderDetailsError: action.isOrderDetailsError,
                isOrderDetailsLoaded: action.isOrderDetailsLoaded
            }
        }
        default:
            return state;
    }
}